class ShopifyDataFeedApiFormsModal extends window.ShopifyFormsModalBase {
  constructor() {
    super();
    this.form = this.querySelector('[data-data-feed-api-forms-form]');
    this.partnershipStatusOptions = this.querySelectorAll('[data-partnership-status]');
    this.intendedUsePanel = this.querySelector('[data-intended-use-panel]');
    this.noApprovalPanel = this.querySelector('[data-no-approval-panel]');
    this.intendedUseTextarea = this.querySelector('textarea[name="intendedUse"]');
    this.agreementSection = this.querySelector('[data-agreement-section]');
    this.noAgreementWarning = this.querySelector('[data-no-agreement-warning]');
    this.agreementChain = [
      { options: this.querySelectorAll('[data-accuracy-agreement-accepted]'), nextPanel: this.querySelector('[data-approval-revocation-panel]') },
      { options: this.querySelectorAll('[data-approval-revocation]'),         nextPanel: this.querySelector('[data-confidentiality-security-panel]') },
      { options: this.querySelectorAll('[data-confidentiality-security]'),    nextPanel: this.querySelector('[data-permitted-use-panel]') },
      { options: this.querySelectorAll('[data-permitted-use]'),               nextPanel: this.querySelector('[data-data-ownership-panel]') },
      { options: this.querySelectorAll('[data-data-ownership]'),              nextPanel: this.querySelector('[data-modification-of-terms-panel]') },
      { options: this.querySelectorAll('[data-modification-of-terms]'),       nextPanel: this.querySelector('[data-liability-warranty-panel]') },
      { options: this.querySelectorAll('[data-liability-warranty]'),          nextPanel: this.querySelector('[data-indemnification-panel]') },
      { options: this.querySelectorAll('[data-indemnification]'),             nextPanel: this.querySelector('[data-compliance-with-laws-panel]') },
      { options: this.querySelectorAll('[data-compliance-with-laws]'),        nextPanel: this.querySelector('[data-governing-jurisdiction-panel]') },
      { options: this.querySelectorAll('[data-governing-jurisdiction]'),      nextPanel: this.querySelector('[data-signature-panel]') },
    ];

    this.stringFields = [
      'legalBusinessName', 'companyWebsite',
      'addressLine1', 'addressLine2', 'city', 'stateProvince', 'postalCode', 'country',
      'fullName', 'jobTitle', 'businessEmail', 'phone',
      'techContactName', 'techContactEmail',
      'partnershipStatus', 'intendedUse',
      'signature', 'signatureDate',
    ];
    this.booleanFields = [
      'accuracyAgreementAccepted',
      'approvalRevocationAccepted',
      'confidentialitySecurityAccepted',
      'permittedUseAccepted',
      'dataOwnershipAccepted',
      'modificationOfTermsAccepted',
      'liabilityWarrantyAccepted',
      'indemnificationAccepted',
      'complianceWithLawsAccepted',
      'governingJurisdictionAccepted',
    ];
  }

  connectedCallback() {
    super.connectedCallback();
    this.boundHandlePartnershipStatusChange = this.handlePartnershipStatusChange.bind(this);
    this.boundHandleAgreementChange = this.handleAgreementChange.bind(this);

    this.partnershipStatusOptions.forEach((input) => {
      input.addEventListener('change', this.boundHandlePartnershipStatusChange);
    });
    this.agreementChain.forEach(({ options }) => {
      options.forEach((input) => {
        input.addEventListener('change', this.boundHandleAgreementChange);
      });
    });

    this.togglePartnershipPanels();
  }

  disconnectedCallback() {
    this.partnershipStatusOptions.forEach((input) => {
      if (this.boundHandlePartnershipStatusChange) {
        input.removeEventListener('change', this.boundHandlePartnershipStatusChange);
      }
    });
    this.agreementChain.forEach(({ options }) => {
      options.forEach((input) => {
        if (this.boundHandleAgreementChange) {
          input.removeEventListener('change', this.boundHandleAgreementChange);
        }
      });
    });
    super.disconnectedCallback();
  }

  getPartnershipStatus() {
    const checked = Array.from(this.partnershipStatusOptions).find((input) => input.checked);
    return checked ? checked.value : null;
  }

  isNoPartnership() {
    const status = this.getPartnershipStatus();
    return status === 'No' || status === 'Pending Approval';
  }

  handlePartnershipStatusChange() {
    this.togglePartnershipPanels();
  }

  togglePartnershipPanels() {
    const status = this.getPartnershipStatus();
    const isApproved = status === 'Yes - Approved Distributor' || status === 'Yes - Approved Reseller';
    const isNo = status === 'No' || status === 'Pending Approval';

    if (this.intendedUsePanel) {
      this.intendedUsePanel.classList.toggle('hidden', !isApproved);
    }
    if (this.intendedUseTextarea) {
      this.intendedUseTextarea.disabled = !isApproved;
      if (!isApproved) this.intendedUseTextarea.value = '';
    }

    if (this.noApprovalPanel) {
      this.noApprovalPanel.classList.toggle('hidden', !isNo);
    }

    if (this.agreementSection) {
      this.agreementSection.classList.toggle('hidden', !isApproved);
      if (!isApproved) {
        this.agreementChain[0].options.forEach((input) => {
          input.checked = false;
          input.setCustomValidity('');
        });
      }
    }

    this.toggleAgreementCascade();
  }

  toggleAgreementCascade() {
    let allPreviousAgreed = true;
    let anyNoSelected = false;

    for (const { options, nextPanel } of this.agreementChain) {
      const checked = Array.from(options).find((input) => input.checked);
      const thisAgreed = checked && checked.value === 'Yes, I agree';
      if (checked && checked.value === 'No, I do not agree') anyNoSelected = true;
      const show = allPreviousAgreed && thisAgreed;

      if (nextPanel) {
        nextPanel.classList.toggle('hidden', !show);
        nextPanel.querySelectorAll('input, textarea, select').forEach((el) => {
          if (!show) {
            el.disabled = true;
            if (el.type === 'radio' || el.type === 'checkbox') {
              el.checked = false;
              el.setCustomValidity('');
            } else {
              el.value = '';
            }
          } else {
            el.disabled = false;
          }
        });
      }

      if (!thisAgreed) allPreviousAgreed = false;
    }

    if (this.noAgreementWarning) {
      this.noAgreementWarning.classList.toggle('hidden', !anyNoSelected);
    }

    this.syncFormFooter();
  }

  syncFormFooter() {
    if (!this.formFooter) return;
    const signaturePanel = this.querySelector('[data-signature-panel]');
    const signatureVisible = signaturePanel && !signaturePanel.classList.contains('hidden');
    this.formFooter.classList.toggle('hidden', this.isNoPartnership() || !signatureVisible);
  }

  handleAgreementChange() {
    this.validateAgreements();
    this.toggleAgreementCascade();
  }

  validateAgreements() {
    this.agreementChain.forEach(({ options }) => {
      const noOption = Array.from(options).find((input) => input.value === 'No, I do not agree');
      const yesOption = Array.from(options).find((input) => input.value === 'Yes, I agree');
      if (noOption && noOption.checked) {
        noOption.setCustomValidity('You must agree to the terms to submit this request.');
      } else {
        if (noOption) noOption.setCustomValidity('');
        if (yesOption) yesOption.setCustomValidity('');
      }
    });
  }

  buildPayload() {
    const payload = super.buildPayload();

    this.booleanFields.forEach((field) => {
      const control = this.form && this.form.elements.namedItem(field);
      if (!control) return;
      const val = control.value;
      if (val === '') {
        delete payload[field];
      } else {
        payload[field] = val;
      }
    });

    return payload;
  }

  resetTransientState() {
    super.resetTransientState();
    this.agreementChain.forEach(({ options }) => {
      options.forEach((input) => input.setCustomValidity(''));
    });
    this.togglePartnershipPanels();
  }
}

if (!customElements.get('shopify-data-feed-api-forms-modal')) {
  customElements.define('shopify-data-feed-api-forms-modal', ShopifyDataFeedApiFormsModal);
}
